import React, { useState } from 'react';

interface PasswordProtectedProps {
  children: React.ReactNode;
}

const PasswordProtected: React.FC<PasswordProtectedProps> = ({ children }) => {
  const [password, setPassword] = useState('');
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [error, setError] = useState(false);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (password.toLowerCase() === 'lauren') {
      setIsAuthenticated(true);
      setError(false);
    } else {
      setError(true);
    }
  };

  if (isAuthenticated) {
    return <>{children}</>;
  }

  return (
    <div className="min-h-screen bg-[#0a0e27] flex items-center justify-center p-4">
      <div className="glass-card rounded-2xl p-8 shadow-2xl max-w-md w-full">
        <h1 className="text-2xl font-bold text-white text-center mb-2">
          Corporate Bookings
        </h1>
        <p className="text-[#94a3b8] text-center mb-6">Quote Generator</p>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-sm font-semibold text-[#e2e8f0] mb-2">
              Enter Password
            </label>
            <input
              type="password"
              value={password}
              onChange={(e) => {
                setPassword(e.target.value);
                setError(false);
              }}
              className={`w-full px-4 py-3 rounded-lg bg-[#1e293b] border text-white placeholder-[#64748b] ${
                error ? 'border-[#f43f5e]' : 'border-[#334155]'
              } focus:ring-2 focus:ring-[#0ea5e9] focus:border-transparent`}
              placeholder="Enter password to access"
              autoFocus
            />
            {error && (
              <p className="text-[#f43f5e] text-sm mt-2">Incorrect password</p>
            )}
          </div>
          <button
            type="submit"
            className="w-full py-3 rounded-lg bg-gradient-to-r from-[#0ea5e9] to-[#06b6d4] text-white font-semibold shadow-md hover:shadow-lg transition-all hover:opacity-90"
          >
            Access Tool
          </button>
        </form>
      </div>
    </div>
  );
};

export default PasswordProtected;
